<div
  class="relative isolate rounded-2xl bg-slate-100 p-1"
  role="radiogroup"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-disabled]="disabled() || null"
>
  <div class="pointer-events-none absolute inset-1" aria-hidden="true">
    <div
      [class]="highlightClasses()"
      [class.opacity-0]="!hasHighlight()"
      [style.width]="highlightWidth()"
      [style.height]="highlightHeight()"
      [style.transform]="highlightTransform()"
    ></div>
  </div>

  <div class="relative z-10 grid gap-2" [style.grid-template-columns]="gridTemplateColumns()">
    @for (option of options(); track option.value) {
      <button
        #optionButton
        class="lowercase"
        type="button"
        role="radio"
        [class]="optionClasses(option)"
        [attr.aria-checked]="isSelected(option.value)"
        [disabled]="disabled() || !!option.disabled"
        [tabIndex]="tabIndexFor($index)"
        (click)="select(option)"
        (focus)="onFocus($event)"
        (blur)="onBlur()"
        (keydown)="onKeyDown($event, $index)"
      >
        {{ option.label }}
      </button>
    }
  </div>
</div>
